// extracted by mini-css-extract-plugin
export var circle = "_18-2";
export var icon = "_18-a";
export var iconHighlight = "_18-0";
export var lg = "_18-8";
export var md = "_18-7";
export var outline = "_18-4";
export var sm = "_18-6";
export var square = "_18-1";
export var xl = "_18-9";
export var xs = "_18-5";
export var xxs = "_18-3";